import React from 'react';
import { Box, Popover, SpaceBetween } from '@amzn/awsui-components-console';
import { getDate } from '../../office-lab/assets/utils';
import { renderStatus } from './utils';

/**
 * Render the trusted caller ARNs of an onboarded role. A single caller is shown as is; several
 * collapse to an "N trusted callers" link whose popover lists one ARN per line, so long ARNs are
 * not cut off in the cell.
 * @param {string[]} callers - caller role/user ARNs allowed to assume the Device Farm role
 */
export function renderTrustedCallers(callers) {
    if (!callers || callers.length === 0) {
        return '-';
    }
    if (callers.length === 1) {
        return callers[0];
    }
    return (
        <Popover
            header="Trusted callers"
            size="large"
            position="bottom"
            triggerType="text"
            renderWithPortal={true}
            content={
                <SpaceBetween size="xxs">
                    {callers.map((arn) => (
                        <Box key={arn}>{arn}</Box>
                    ))}
                </SpaceBetween>
            }
        >
            {`${callers.length} trusted callers`}
        </Popover>
    );
}

export const IAM_ROLE_VISIBLE_COLUMNS = [
    'identity_id',
    'team',
    'status',
    'description',
    'caller_role_arns',
    'requester',
    'ownerGroup',
    'createdAt',
    'lastUpdatedAt',
];
export const SORTED_FILED = {
    id: 'createdAt',
    header: 'Created at',
    cell: (e) => getDate(e.createdAt),
    sortingField: 'createdAt',
    width: 250,
};
export const IAM_ROLE_COLUMNS_DEFINITION = [
    {
        id: 'identity_id',
        header: 'Device Farm role ARN',
        cell: (e) => e.identity_id,
        width: 350,
    },
    {
        id: 'team',
        header: 'Team',
        cell: (e) => e.team,
        width: 150,
    },
    {
        id: 'status',
        header: 'Status',
        cell: (e) => renderStatus(e),
        sortingField: 'status',
        width: 200,
    },
    {
        id: 'description',
        header: 'Description',
        cell: (e) => e.description,
        width: 250,
    },
    {
        id: 'caller_role_arns',
        header: 'Trusted callers',
        cell: (e) => renderTrustedCallers(e.caller_role_arns),
        width: 350,
    },
    {
        id: 'requester',
        header: 'Requester',
        cell: (e) => e.requester,
        width: 150,
    },
    {
        id: 'ownerGroup',
        header: 'Owner group',
        cell: (e) => e.ownerGroup,
        width: 200,
    },
    SORTED_FILED,
    {
        id: 'lastUpdatedAt',
        header: 'Last updated at',
        cell: (e) => getDate(e.lastUpdatedAt),
        width: 250,
    },
];
export const COLLECTION_PREFERENCES_PROPS = {
    pageSizePreference: {
        title: 'Select page size',
        options: [
            { value: 20, label: '20 roles' },
            { value: 50, label: '50 roles' },
            { value: 100, label: '100 roles' },
        ],
    },
    visibleContentPreference: {
        title: 'Select visible columns',
        options: [
            {
                label: 'Main properties',
                options: IAM_ROLE_COLUMNS_DEFINITION.map(({ id, header }) => ({
                    id,
                    label: header,
                    editable: id !== 'identity_id',
                })),
            },
        ],
    },
    cancelLabel: 'Cancel',
    confirmLabel: 'Confirm',
    title: 'Preferences',
    stickyColumnsPreference: {
        firstColumns: {
            title: 'Freeze first column(s)',
            description: 'Keep the first column(s) visible while horizontally scrolling the table content.',
            options: [
                { label: 'None', value: 0 },
                { label: 'First column', value: 1 },
            ],
        },
    },
};
